import * as React from 'react'
import { FC } from 'react'
import { FieldProps } from 'ra-ui-materialui'
import { useController } from 'react-hook-form'

type HiddenFieldProps = FieldProps & {
  source: string
  value: string
}

export const HiddenField: FC<HiddenFieldProps> = ({ source, value, ...rest }) => {
  const { field } = useController({ name: source, defaultValue: value })
  return <input {...field} type="hidden" {...rest} />
}
